export const policyIconMap = new Map<
  string,
  {
    icon: string;
    iconColor: string;
  }
>([
  [
    'Accident and health',
    {
      icon: 'accident_thin',
      iconColor: 'orange',
    },
  ],
  [
    'Agriculture and forestry',
    {
      icon: 'agriculture_thin',
      iconColor: 'green',
    },
  ],
  [
    'Auto or Motor',
    {
      icon: 'auto_motor_thin',
      iconColor: 'orange',
    },
  ],
  [
    'Aviation',
    {
      icon: 'aviation_thin',
      iconColor: 'blue',
    },
  ],
  [
    'Casualty / Liability',
    {
      icon: 'casualty_liability_thin',
      iconColor: 'red',
    },
  ],
  [
    'Checkmate',
    {
      icon: 'checkmate_thin',
      iconColor: 'yellow',
    },
  ],
  [
    'Contingency',
    {
      icon: 'contingency_thin',
      iconColor: 'yellow',
    },
  ],
  [
    'Cyber',
    {
      icon: 'cyber_thin',
      iconColor: 'orange',
    },
  ],
  [
    'Energy',
    {
      icon: 'energy_thin',
      iconColor: 'yellow',
    },
  ],
  [
    'Engineering',
    {
      icon: 'engineering_thin',
      iconColor: 'orange',
    },
  ],
  [
    'Financial',
    {
      icon: 'financial_thin',
      iconColor: 'green',
    },
  ],
  [
    'Internal Accounting',
    {
      icon: 'internal_accounting_thin',
      iconColor: 'pink',
    },
  ],
  [
    'LSOS Master Policy',
    {
      icon: 'lsos',
      iconColor: 'yellow',
    },
  ],
  [
    'Life',
    {
      icon: 'product_thin',
      iconColor: 'pink',
    },
  ],
  [
    'Marine',
    {
      icon: 'marine_thin',
      iconColor: 'blue',
    },
  ],
  [
    'Miscellaneous',
    {
      icon: 'misc_thin',
      iconColor: 'grayMedium',
    },
  ],
  [
    'Norway',
    {
      icon: 'norway_thin',
      iconColor: 'red',
    },
  ],
  [
    'Pensions',
    {
      icon: 'pensions_thin',
      iconColor: 'pink',
    },
  ],
  [
    'Political risks',
    {
      icon: 'pensions_thin',
      iconColor: 'blue',
    },
  ],
  [
    'Project',
    {
      icon: 'project_thin',
      iconColor: 'pink',
    },
  ],
  [
    'Property',
    {
      icon: 'property_thin',
      iconColor: 'yellow',
    },
  ],
  [
    'Umbrella Liability',
    {
      icon: 'umbrella_thin',
      iconColor: 'yellow',
    },
  ],
]);
